export type PlanningType =
  | 'Private Dance Classes'
  | '1-on-1 Coaching'
  | 'Couples Lessons'
  | 'Wedding'
  | 'Quinceañera'
  | 'Group Coaching'
  | 'Competition Coaching'
  | 'Competition Choreography'
  | 'Custom Choreography'
  | 'Corporate Event'
  | 'Professional Performance'
  | 'Live Entertainment'
  | 'School / Studio Project'
  | 'Artist / Music Video'
  | 'Other';

export type PreferredLanguage = 'English' | 'Español';

export interface QuoteFormData {
  planningType: PlanningType | null;
  eventDate: string;
  noDateYet: boolean;
  location: string;
  groupSize: string;
  vision: string;
  name: string;
  email: string;
  phone: string;
  preferredLanguage: PreferredLanguage;
}

export const emptyQuoteForm: QuoteFormData = {
  planningType: null,
  eventDate: '',
  noDateYet: false,
  location: '',
  groupSize: '',
  vision: '',
  name: '',
  email: '',
  phone: '',
  preferredLanguage: 'English',
};
